export default __webpack_public_path__ + "static/media/more.607ae51b.svg";